export const USER_EP = '/personal-api/v1/user/'
export const USER_LIST_EP = '/personal-api/v1/users/'
export const ADD_USER_EP = '/personal-api/v1/users/add/'
export const USER_LOGOUT_EP = '/personal-api/v1/user/logout/'
export const USER_LOGIN_EP = '/personal-api/v1/user/login/'
export const REQUEST_RESET_PASSWORD_EP = '/personal-api/v1/user/request-password-reset/'
export const RESET_PASSWORD_EP = '/personal-api/v1/user/password-reset/'
export const POST_USER_PERMISSIONS_EP = (userId: number) => `/personal-api/v1/users/permissions/${userId}/`
export const MFA_SETUP = '/personal-api/v1/user/mfa/setup/'
export const MFA_VERIFY = '/personal-api/v1/user/mfa/verify/'
export const MFA_DISABLE = '/personal-api/v1/user/mfa/disable/'
